module.exports = __webpack_public_path__ + "static/media/css3.a32f83aa.png";